import Helmet from "react-helmet";
import FeatureCards from "../../components/featureCards";
import Footer from "../../components/footer";
import "./style.scss";
import NavBar from "../../components/navbar";

const PrivacyPolicy = () => {
  return (
    <>
      <Helmet>
        <title>TekStrive - About</title>
      </Helmet>
      <NavBar />
      <div className="about-container">
        <Hero />
        <Privacy />
        <Footer />
      </div>
    </>
  );
};

const Hero = () => {
  return (
    <>
      <section className="section-global bg-shade-blue hero">
        <div className="container">
          <div className="row">
            <div className="col-lg-7">
              <div className="section-tag mb-8">Privacy Policy-TekStrive</div>
              <h1 className="display-1">Your Privacy Matters to Us</h1>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

const Privacy = () => {
  return (
    <>
      <div className="privacy-policy">
        <p className="section-tag">Effective Date: 12-02-2025</p>

        <h2>1. Introduction</h2>
        <p>
          Welcome to Tekstrive LLC ("Company", "we", "our", "us"). This
          Privacy Policy explains how we collect, use, disclose, and safeguard
          your information when you visit our website https://tekstrive.org/, including
          any other media form, media channel, mobile website, or mobile
          application related or connected thereto (collectively, the "Site").
          Please read this privacy policy carefully. If you do not agree with
          the terms of this privacy policy, please do not access the site.
        </p>

        <h2>2. Information We Collect</h2>
        <p>
          We may collect information about you in a variety of ways. The
          information we may collect on the Site includes:
        </p>
        <ul>
          <li>
            <strong>Personal Data:</strong> Personally identifiable information,
            such as your name, shipping address, email address, and telephone
            number, and demographic information, such as your age, gender,
            hometown, and interests, that you voluntarily give to us when you
            register with the Site or when you choose to participate in various
            activities related to the Site, such as online chat and message
            boards.
          </li>
          <li>
            <strong>Derivative Data:</strong> Information our servers
            automatically collect when you access the Site, such as your IP
            address, your browser type, your operating system, your access
            times, and the pages you have viewed directly before and after
            accessing the Site.
          </li>
          <li>
            <strong>Financial Data:</strong> Financial information, such as data
            related to your payment method (e.g., valid credit card number, card
            brand, expiration date) that we may collect when you purchase,
            order, return, exchange, or request information about our services
            from the Site.
          </li>
        </ul>

        <h2>3. Use of Your Information</h2>
        <p>
          Having accurate information about you permits us to provide you with a
          smooth, efficient, and customized experience. Specifically, we may use
          information collected about you via the Site to:
        </p>
        <ul>
          <li>Create and manage your account.</li>
          <li>Process your transactions and send you related information.</li>
          <li>
            Send you administrative information, such as updates, security
            alerts, and support messages.
          </li>
          <li>
            Respond to your comments, questions, and requests, and provide
            customer service.
          </li>
          <li>
            Monitor and analyze trends, usage, and activities in connection with
            our Site.
          </li>
          <li>
            Prevent fraudulent transactions, monitor against theft, and protect
            against criminal activity.
          </li>
          <li>Comply with legal obligations and enforce our agreements.</li>
        </ul>

        <h2>4. Disclosure of Your Information</h2>
        <p>
          We may share information we have collected about you in certain
          situations. Your information may be disclosed as follows:
        </p>
        <ul>
          <li>
            <strong>By Law or to Protect Rights:</strong> If we believe the
            release of information about you is necessary to respond to legal
            process, to investigate or remedy potential violations of our
            policies, or to protect the rights, property, and safety of others,
            we may share your information as permitted or required by any
            applicable law, rule, or regulation.
          </li>
          <li>
            <strong>Third-Party Service Providers:</strong> We may share your
            information with third parties that perform services for us or on
            our behalf, including payment processing, data analysis, email
            delivery, hosting services, customer service, and marketing
            assistance.
          </li>
          <li>
            <strong>Business Transfers:</strong> We may share or transfer your
            information in connection with, or during negotiations of, any
            merger, sale of company assets, financing, or acquisition of all or
            a portion of our business to another company.
          </li>
        </ul>

        <h2>5. Security of Your Information</h2>
        <p>
          We use administrative, technical, and physical security measures to
          help protect your personal information. While we have taken reasonable
          steps to secure the personal information you provide to us, please be
          aware that despite our efforts, no security measures are perfect or
          impenetrable, and no method of data transmission can be guaranteed
          against any interception or other type of misuse.
        </p>

        <h2>6. Policy for Children</h2>
        <p>
          We do not knowingly solicit information from or market to children
          under the age of 13. If we learn that we have collected personal
          information from a child under age 13 without verification of parental
          consent, we will delete that information as quickly as possible. If
          you become aware of any data we have collected from children under age
          13, please contact us at info@tekstrive.com.
        </p>

        <h2>7. Changes to This Privacy Policy</h2>
        <p>
          We may update this Privacy Policy from time to time in order to
          reflect, for example, changes to our practices or for other
          operational, legal, or regulatory reasons. We will notify you of any
          changes by posting the new Privacy Policy on the Site. You are advised
          to review this Privacy Policy periodically for any changes. Changes to
          this Privacy Policy are effective when they are posted on this page.
        </p>

        <h2>8. Contact Us</h2>
        <p>
          If you have questions or comments about this Privacy Policy, please
          contact us at:
        </p>
        <p>
          Tekstrive LLC
          <br />
          S Preston Road,Unit 940,Prosper 
          <br />
          Texas,75078
          <br />
          info@tekstrive.com
          <br />
          +1 972-591-6655
        </p>
      </div>
    </>
  );
};

export default PrivacyPolicy;
